import { State } from '../../../store/state';

export const metricTypesSelector = (state: State) => state.metrics.metricTypes;
export const metricTypeSelector = (state: State) => state.metrics.metricType;
export const graphTypesSelector = (state: State) => state.metrics.graphTypes;
export const graphTypeSelector = (state: State) => state.metrics.graphType;
export const gridSelector = (state: State) => state.metrics.grid;
export const overviewSelector = (state: State) => state.metrics.overview;
export const countersSelector = (state: State) => state.metrics.counters;
export const distributionsSelector = (state: State) => state.metrics.distributions;
export const productsSelector = (state: State) => state.metrics.products;
export const dateInitSelector = (state: State) => state.metrics.dateInit;
export const dateEndSelector = (state: State) => state.metrics.dateEnd;
export const storeSelector = (state: State) => state.metrics.store;
export const errorCodeSelector = (state: State) => state.metrics.errorCode;
